import { useEffect, useState } from 'react';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { itIT } from '@mui/x-data-grid/locales';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export default function UsersTable({ usersData }) {

  const userColumns = [
    { field: 'name', headerName: 'Nome', editable: false, hideable: false, flex: 0.5 },
    { field: 'surname', headerName: 'Cognome', editable: false, hideable: false, flex: 0.5 },
    { field: 'birth_date', headerName: 'Data di nascita', editable: false, flex: 0.5 },
    { field: 'place_of_birth', headerName: 'Luogo di nascita', editable: false, flex: 1 },
    { field: 'fiscal_code', headerName: 'Codice Fiscale', editable: false, hideable: false, flex: 1 },
    { field: 'entity_id', headerName: 'Circolo di appartenenza', editable: false, hideable: false, flex: 0.5 },
    { field: 'email', headerName: 'Email', editable: false, flex: 1 },
    { field: 'call_code', headerName: 'Prefisso', editable: false, flex: 0.5 },
    { field: 'phone', headerName: 'Telefono', editable: false, flex: 1 },
    {
      field: 'res_equal_home',
      headerName: 'Domicilio = Residenza',
      editable: false,
      hideable: true,
      flex: 1,
      type: 'boolean',
      renderCell: (params) =>
        params.value ? <CheckIcon style={{ color: 'green' }} /> : <CloseIcon style={{ color: '#d0342b' }} />,
    },
    { field: 'res_street', headerName: 'Indirizzo di residenza', editable: false, hideable: true, flex: 0.5 },
    { field: 'res_zip_code', headerName: 'CAP di residenza', editable: false, hideable: true, flex: 0.5 },
    { field: 'res_city_id', headerName: 'Città di residenza', editable: false, hideable: true, flex: 0.5 },
    { field: 'res_city_name', headerName: 'Città di residenza estera', editable: false, hideable: true, flex: 0.5 },
    { field: 'res_province_id', headerName: 'Provincia di residenza', editable: false, hideable: true, flex: 0.5 },
    { field: 'res_region_name', headerName: 'Regione di residenza estera', editable: false, hideable: true, flex: 0.5 },
    { field: 'res_country_id', headerName: 'Paese di residenza', editable: false, hideable: true, flex: 0.5 },
    { field: 'home_street', headerName: 'Indirizzo di domicilio', editable: false, hideable: true, flex: 0.5 },
    { field: 'home_zip_code', headerName: 'CAP di domicilio', editable: false, hideable: true, flex: 0.5 },
    { field: 'home_city_id', headerName: 'Città di domicilio', editable: false, hideable: true, flex: 0.5 },
    { field: 'home_city_name', headerName: 'Città di domicilio estero', editable: false, hideable: true, flex: 0.5 },
    { field: 'home_province_id', headerName: 'Provincia di domicilio', editable: false, hideable: true, flex: 0.5 },
    { field: 'home_region_name', headerName: 'Regione di domicilio estera', editable: false, hideable: true, flex: 0.5 },
    { field: 'home_country_id', headerName: 'Paese di domicilio', editable: false, hideable: true, flex: 0.5 },
    { field: 'position_id', headerName: 'Carica', editable: false, hideable: true, flex: 0.5 },

    {
      field: 'allow_news',
      headerName: 'Consenso Comunicazioni',
      editable: false,
      hideable: true,
      flex: 1,
      type: 'boolean',
      renderCell: (params) =>
        params.value ? <CheckIcon style={{ color: 'green' }} /> : <CloseIcon style={{ color: '#d0342b' }} />,
    }
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarExport csvOptions={{ allColumns: true }} printOptions={{ disableToolbarButton: true }} />
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <DataGrid
        disableRowSelectionOnClick
        rows={usersData}
        columns={userColumns}
        slots={{ toolbar: CustomToolbar }}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        pageSizeOptions={[10]}
        getRowId={(row) => row.fiscal_code}
        initialState={{
          ...usersData.initialState,
          pagination: { paginationModel: { pageSize: 10 } },

          columns: {
            ...usersData.initialState?.columns,
            columnVisibilityModel: {
              res_equal_home: false,
              res_street: false,
              res_zip_code: false,
              res_city_id: false,
              res_province_id: false,
              res_region_name: false,
              res_country_id: false,
              home_street: false,
              home_zip_code: false,
              home_city_id: false,
              home_province_id: false,
              home_region_name: false,
              home_country_id: false,
              allow_news: false,
              verified: false,
            },
          },
        }}
      />
    </>
  );
}
